import { ReactNode } from 'react';
import ReactModal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { closeModal as closeModalAction } from '../../../untidy/redux/modules/modal';
import { getOpenModal } from '../../../untidy/redux/selectors';
import { CloseButton, Main, stylesOverride, Title, TitleBlock } from './styles-private';

ReactModal.setAppElement('body');

interface Props {
  modalName: string;
  title?: string;
  disableClose?: boolean;
  children: (d: { closeModal: () => void }) => ReactNode;
}

// workaround for contribution forms that
// don't have proper titles
const NoTitleCloseButton = styled.div`
  cursor: pointer;
  font-size: 24px;
  text-align: right;
  position: absolute;
  right: 18px;
  top: 12px;
`;

export function Modal(props: Props) {
  const { modalName, children, disableClose, title } = props;

  const openModal = useSelector(getOpenModal);
  const isOpen = !!openModal && openModal.name === modalName;
  const dispatch = useDispatch();
  const closeModal = () => dispatch(closeModalAction(modalName));

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel={modalName}
      shouldCloseOnOverlayClick={!disableClose}
      style={stylesOverride}
    >
      {title ? (
        <TitleBlock>
          <Title>{title}</Title>
          <CloseButton aria-label={`Close ${modalName} modal`} onClick={closeModal}>
            &times;
          </CloseButton>
        </TitleBlock>
      ) : (
        <NoTitleCloseButton aria-label={`Close ${modalName} modal`} onClick={closeModal}>
          &times;
        </NoTitleCloseButton>
      )}
      <Main>{children({ closeModal })}</Main>
    </ReactModal>
  );
}
